import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const streamingProviderStore = create(
  persist(
    (set, get) => ({
      streamingProvider: 'cloudflare',
      setStreamingProvider: (provider) => {
        set((state) => ({
          ...state,
          streamingProvider: provider,
        }));
      },
    }),
    {
      name: "streaming-provider-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default streamingProviderStore;
